export default __webpack_public_path__ + "static/media/copyright.ab6a078f.svg";